import React, { useState } from 'react';

const semifinalists = [
  "Maheen Imran Shaikh", "Rassul Zhunussov", "Pranava Senathipathi Kumar", "Tatev Dadian",
  "Anjali Sharma-Tiwari", "Ameya Shirguppe", "Zalea Nunes", "Anya Goel", "Arjun Karapakula",
  "Cyrus Law", "Ramona (Mona) Valiollahi", "Vishnu Vijay", "Jarupat Bulpakdi", "Toha Abedin",
  "Devesh Aggarwal", "Omar Emam", "Aanya Gupta", "Jacob Mingen Gu", "Turiya Misra",
  "Seokhwan Jang", "Darara Negussie Meskela", "Cyrus Ghane", "Aimee Yu Zhang", "Chen You'An",
  "Md Towhidur Rahman Sakib", "Mariam Tutayeva", "Kyle Anthony J. Roberto", "Shawn Kim",
  "Amna Abid", "Joshua Wung", "Lily Chen", "Armaan Diwan", "Saahil Shah", "Sai Likhith Karri",
  "Ameya Kharade", "Meruyert Amangeldy", "Jayden Joseph", "Sammit Chidambaram",
  "Charlotte Sze Wai Wong", "Aru Lesbek", "Abdullah Goraya", "Ojaswi Singh",
  "Subanth Nanda Kumar", "Catherine Yang", "Keerthana Anumukonda", "Pradhyumna Vasishta",
  "Devesh Tiwari", "Armin Stamate", "Amber Ho Yiu Chow", "Aharon Aguirre", "Jingyi Ling",
  "Jasmine Sun", "Kanushi Desai", "Fernando Alonso Cruz Ng Ying", "Abhinav Shah",
  "Neal Shandilya", "Daksh Mannadath", "Dhairya Mittal", "Ethan Wei", "Rudransh Singh Palta",
  "Iris Tong", "Rudra Boghani", "Maria Galicia", "Tanvi Nare", "Claire Cao", "Kevin Ouyang",
  "Liu Shuyu, Fish", "V. Sang", "Sultan Sailau", "Anahitaa Jain", "Sajeel Muhymin Vehra",
  "Adhvay Karthikeyan", "Sophia Hou", "Julia Maksimowicz", "Hina Yamamoto", "Timur Petanin",
  "Alijawad Peera", "Taeho Kim", "Isabella Podesta", "Abhijay Chaudhari", "Supriya Krishnamurthy",
  "Jack Agata Pexton", "Ishaan Shailesh Surve", "Yuvan Aggarwal", "Hridank Shukla",
  "Bhrigu Uppal", "Hayden Chen", "Michael Wang", "Panita Chantravekin", "William Liang",
  "Sanjith Sowrirajan", "Hyunbin Seo", "Akash Saran", "Adithya V. Sastry", "Kelly Lock",
  "Advait Swaminathan", "George Thomas", "Hridhaan Sanat Banerjee", "Uktamjon Komiljonov",
  "Roneet Dhar", "Neo Xuan Che", "Mehaan Sibal", "Kayley Xu", "Shankar Harikrishnan",
  "Annie Zhu", "Raymond Chen", "Venkata Anirudh Devireddy", "Martin Izquierdo", "Anya Gruteser",
  "Sahasrad Sathish", "Guransh", "Mardochee Joseph", "Colin Ding", "Sria Siva", "Zahid Syed",
  "Trashgim Mulosmani", "Hrishikesh Satish", "Vedh Reddy", "Rishit Anand", "Rachel Dina Rakower",
  "Srishti Hazra", "Arjun Desikan", "Sangwoo Kim", "Ishaan Kumar", "Boze Jia", "Aaryan Parveen",
  "Benjamin Vaccaro", "Ganendra Bisma Mahardika", "Hazem Taha", "Satya Sriram Kokonda",
  "Abdallah Roshdy Elsyed", "Aarav Trivedi", "Varun Kumar Hittuvalli", "Abhay Gupta",
  "Timothy Hajin Park", "Yufei (Joanna) Jiang", "Rafael Matteo Dollet", "Baruni Soni",
  "Ali Zaruov", "Ved Reddy", "Saketh Singamsetty", "Omer Mescioglu", "Mishri Buddhadev",
  "Shivansh Shukla", "Ariana Kam", "Mikhail Ibrahim", "Sz Kiu Priscilla Leung",
  "Leon Jiaxing Yuan", "Aye Myatt Naing", "Ansh Gupta", "Varshith Vijjapu",
  "Srenithi Ganesa Moorthy", "Jonathan Liu", "Kriti Atluri", "Morgan Selzler",
  "Mikhail Zotov Nikolaevich", "Muhammad Zayann Yasir", "Amir Mahmoud Ghanem", "Michelle Zhou",
  "Charlie Wang", "Alex Vladimir", "Yuqi Zhang", "Shengtian Hong", "Roshan Amurthur",
  "Siddharth Yenamandra", "Saket Parayil", "Chetas Aduri", "Neya Rajasingh", "Ariane McDermott",
  "Arjun Arobind Nair", "Marcus Deng", "Dhrithi Karavadi", "Jing Yao Yang", "Zachary Pan",
  "Lily Bombay", "Thora Mattina Gudmundsdottir", "Rafael Dollet", "Chloe Angela Li",
  "Avyukt Satish", "Anthony Wang", "Julian Moncarz", "Arav Kumar", "Shresta Morisetty",
  "Aiden Chun", "Rohan Manchanda", "Eashan Rautaray", "Dhruv Nair", "Jasper Tay",
  "Ishaan Kabra", "Julia Liang", "Akshay Thanipet Padmanabhan", "Arda Deniz Kanli",
  "Eliza Zdych", "Rheann Laureiz Sioco", "Tianle Liang", "Ha-Mim Rahman", "Shreeya Rao Lalam",
  "Leo Tang", "Lotus Gao", "Denis Boudaliez", "Russell Liu", "Kwan Tsz Kin", "Ozair Ahmad Khan",
  "Adi Yenuubarii", "Sayak Moulic", "Arth Dalsania", "Liang Zhiying", "Pradhyun Goud Akkala",
  "Mabel Yang", "Isabel Goh", "Mabinty Keita", "Rastin Emrani", "Divya Jayam", "Tristan Park",
  "Yongen Shen", "Joshua Huang", "Simone Maimon", "Adhrit Srinivasan", "Ayzah Salim Jujara",
  "Ghrini Sai Jella", "Lu Renyi", "Vrishank Adya Mallela", "Eshna Saigol", "Vihaan Kinra",
  "Sophie Katherine Huang", "Ajsel Budlla", "Aw Jun Hong", "Le Minh Ngoc", "Jeffrey Huang",
  "Aryan Kohli", "Bhargav Shah", "Sam-Haendell Thosiac", "Shiven Das", "Ahana Tajnim Khan",
  "Evelyn Yao", "Sai Akshith Challagolla", "Malak Omer", "Ivy Yuetian Ma", "Yao",
  "Lasya Gudibanda", "Arjun Skanda Ananda", "Sami Ihsan Sazci", "Samuel Han", "Arsh Jha",
  "Stella Myers", "Sai Raghav Ganesh", "Sreemahati Periyala", "Chloe Lam", "Adwita Jagannathan",
  "Yanrui Li", "Emily Nguyen", "Akhil Yalamanchili", "Anvith Neelam", "Yuancheng Luo",
  "Tanvi Gupta", "Attrey Koul", "Jade Lam", "Vethaanthikaa Karthikeyan", "Elie Ciril",
  "Chris Huy Nguyen", "Jyotirmay Meena", "Bhavya Babbellapati", "Elizabeth Vinokurov",
  "Rayhan Roswendi", "Chizorom Elleora Okoro", "Syeda Zainab Fatima", "Rishika Kurma",
  "Jaelyn Jin", "Diya Venkataragavan", "Heshika Vaitheeswaran", "Eshan Geadam",
  "Prashasti Huliya", "Namay Khandelwal", "Ashika Sharma", "Sriniketh Sarangapani",
  "Vivin Baluraj", "Jae Gyun Lim", "Aryaman Gupta", "Joonseong Lim", "Anandhitha Arasu",
  "Aaron Pinto", "Sanwarya Ramani", "Abhijay R Kodadala", "Ashish Mulabagili", "Benicio Olson",
  "Aditya Yadav", "Jahnavi Sharma", "Sophie Huang", "Aarushi Sharma"
];

function Semifinals() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = semifinalists.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 20, 2025
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2025 Semi-Finalists
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', marginBottom: '16px' }}>
          <strong>Congratulations to the IRO semi-finalists!</strong> The top 15% of participants have advanced to the semifinals round.
        </p>
      </div>

      {/* Quote Card */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '16px',
        padding: '32px',
        marginBottom: '40px',
        borderLeft: '4px solid #004d99'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '12px' }}>
          "We believe your potential in research is unlimited and deep. We stand committed to making this community into a close, innovative, welcoming, and supportive society around student research aspirations."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', margin: 0 }}>
          — Rishab Jain, President, IRO
        </p>
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {semifinalists.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Semi-Finalists</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 15%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default Semifinals;
